module.exports = __webpack_public_path__ + "static/media/star-without-bg.c6197458.svg";